import React from 'react'
import styled from 'styled-components'

const HeaderContainer = styled.div`
  background-color: black;
  height: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeaderText = styled.h1`
  font-size: 24px;
  font-weight: bold;
  color: #333;
`;

const Header: React.FC = () => {
  return (
    <HeaderContainer>
      <HeaderText></HeaderText>
    </HeaderContainer>
  );
};

export default Header;
